/*
 *
 * Alerts constants
 *
 */

export const ADD_ALERT = 'app/Alerts/ADD_ALERT';
export const DISMISS_ALERT = 'app/Alerts/DISMISS_ALERT';
export const CLEAR_ALERTS = 'app/Alerts/CLEAR_ALERTS';
